import React, { useState,useEffect } from 'react'
import { Breadcrumbs } from '../../../../../../components/breadcrumbs/Breadcrumbs';
import { Banner } from '../../../../../../components/banner/Banners';
import IMAGES from '../../../../../../assets/images/images';
import { useParams } from 'react-router-dom';
import { ChildContainer, Container } from '../../../../../../components/Container/Containers';
import styles from './onboardingDetail.module.css';
import { useNavigate } from 'react-router-dom';
import  AddComment  from '../addComment/addComment.container';
import SectionGuard from '../../../../../../hoc/guards/SectionGuard';
import { Action, Resource } from '../../../../../../casl/constants';
import CAN from '../../../../../../casl/can';
import { Loader } from '../../../../../../components/loader/Loader';
import { dueDate, formatDate, useNotificationId } from '../../../../../../utils/arrayUtils';
import InfiniteScroll from 'react-infinite-scroll-component';
import { FUNCTIONAL_ROLES_CONSTANTS, USER_TYPE } from '../../../../../../utils/constants/userConstants';
import { ON_BOARDING_STATUS } from '../../../../../../utils/constants/userManagementConstant';
import { Incident_Service_Type_Values } from '../../../../../../utils/constants/incidentConstants';
import { getLogo } from '../../../../../../utils/constants/fileTypeLogo';
import SecondaryTooltip from '../../../../../../components/secondaryToolTip/secondaryToolTip';

const OnboargingDetailList = ({ data, myRigths,onFileDownload}) => {
    const [isOpen, setIsOpen] = useState(false);
  
    const toggleContent = () => {
      setIsOpen(!isOpen);
    };
    
  const navigate = useNavigate();

  const back = (requestId) => {
    navigate(-1);
    // navigate(`/user-management/onboardingApprovals`);
  }

  const [isExpanded, setIsExpanded] = useState(false);
  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };
  // const text = data?.additionalInfoText;
  // const previewText = text?.slice(0, 100);
  // const showViewMore = text?.length>100

  const text = data?.additionalInfoText ? data?.additionalInfoText.split('\n').map((line, index, arr) => {
    if (index === arr.length - 1) {
      return <span key={index}>{line}</span>;
    } else {
      return <div key={index}>{line}</div>;
    }
  }) : "---";

  const previewText = data?.additionalInfoText?.slice(0, 100);
  const newlineIndex = data?.additionalInfoText?.indexOf('\n');
  const newline = newlineIndex !== -1 ? data?.additionalInfoText?.slice(0, newlineIndex) : data?.additionalInfoText;
  const showViewMore = data?.additionalInfoText?.length > 100 ||  data?.additionalInfoText?.includes('\n');
  let splitdata = previewText?.split("\n")

  const downloadFile = (file, index,onDownload) => {
    onDownload(file)
  }

    return (
     <div>
         <div className={styles.back}>
         <div>  
          <span><img className={styles.backbutton} src={IMAGES.backarrow} onClick={()=>back()} /></span>
          <span className={styles.id}>{data?.requestId}</span>
          <span className={`${styles.status} ${styles[data?.requestStatus?.value]}`}> {data?.requestStatus?.label} </span>
        </div>
        {myRigths?.functionalRoles[0] === FUNCTIONAL_ROLES_CONSTANTS["commercial_manager_internal"]?.value&& data?.requestStatus?.value==="pending"&&(
          <>
          {!data?.escalationDue?.status&&(
           <div className={styles.tadiglabel}><span className={styles.alert}>Respond by {dueDate(data?.createdAt)}, or the request will be escalated.</span></div>
          )}
           {data?.escalationDue?.status&&(<span className={styles.exclated}><img className={styles.circleinfo} src={IMAGES.infoCircle}/>The request has been escalated.</span>)}
          </>
        )}
      </div>
      <div className={styles.container}>
      <div className={styles.requestDetail}>Request Details</div>
      <div className={styles.listContent}>
             <div className={styles.list}>
                <div className={styles.label}>Requested On</div>
                <div className={styles.value}>{formatDate(data?.createdAt)}</div>
             </div>
             <div className={styles.list}>
                <div className={styles.label}>Requested By</div>
                <div className={styles.value}><SecondaryTooltip copy={true} text={data?.createdBy?.email} positions={['bottom', 'right']}>{data?.createdBy?.name}</SecondaryTooltip></div>
             </div>
             <div className={styles.list}>
                <div className={styles.label}>Request Assigned To</div>
                <div className={styles.value}>{data?.requestAssignedTo?.label}</div>
             </div>
             {(data?.requestStatus?.value===ON_BOARDING_STATUS.APPROVED ||data?.requestStatus?.value===ON_BOARDING_STATUS.REJECTED)&&(
              <>
                <div className={styles.list}>
                 <div className={styles.label}>{data?.requestStatus?.value===ON_BOARDING_STATUS.APPROVED?"Approved On":"Rejected On"}</div>
                 <div className={styles.value}>{formatDate(data?.modifiedAt)}</div>
                </div>
                <div className={styles.list}>
                 <div className={styles.label}>{data?.requestStatus?.value===ON_BOARDING_STATUS.APPROVED?"Approved By":"Rejected By"}</div>
                 <div className={styles.value}><SecondaryTooltip copy={true} text={data?.modifiedBy?.email} positions={['bottom', 'right']}>{data?.modifiedBy?.name}</SecondaryTooltip></div>
                </div>
              </>
             )}
             </div>
             <div className={styles.label}>Additional Information</div>
             <div className={styles.valueadditionalinfo}>
              {data?.additionalInfoText?
              <>
               <div className={isExpanded ? styles.infotext : styles.infotexts}>
               {/* {isExpanded ? text : `${previewText}${showViewMore?"...":""}`} */}
               {isExpanded ? text : (
       newlineIndex === -1 ? (
       splitdata.map((word, index) => (
      index === splitdata.length - 1 ? (
        <span className={styles.info}key={index}>{word}</span>
      ) : (
        <div className={styles.info} key={index}>{word}</div>
       )
       ))
       ) : (
       <span className={styles.info}>{newline}</span>
      )
     )}
              {showViewMore&&(<span className={styles.viewMore} onClick={handleToggle}>{isExpanded ? " View Less" : " View More"}</span>
              )}
              </div>
              </>:"---"}
             </div>
             
             {/* {data?.additionalInfoAttachments?.length>0 &&(
             <div className={styles.label}>Attachments</div>
             )} */}
             <div className={styles.parent}>
              {data?.additionalInfoAttachments?.map((item,index)=>
              <div className={styles.attachment} key={index}>
              <img className={styles.attachlogo} src={getLogo(item?.originalFileName)} />
              <span className={styles.filename}>{item?.originalFileName}</span>
              <img className={styles.download} src={IMAGES.downloadlogo}  onClick={() => downloadFile(item, index,onFileDownload)} />
              </div>)}
             </div>
     </div>
     </div>
    )
  };

  const OnboargingDetail = ({ data, myRights }) => {
    const [isOpen, setIsOpen] = useState(false);
  
    return (
     <div>
      
      <div className={styles.container}>
      <div className={styles.requestDetail}>Customer Details</div>
      <div className={styles.list}>
            <div className={styles.label}>Organisation Legal name</div>
            <SecondaryTooltip text={data?.displayName} positions={['bottom', 'right']}><div className={`${styles.value} ${styles.valueText}`}>{data?.displayName}</div></SecondaryTooltip>
        </div>
        <div className={styles.requestDetail}>Availed Service</div>
        {data?.requestDetails?.map((detail,index, array)=>
      <>
        <div key={index} className={`${styles.listContent} ${array.length > 1 && index !== array.length - 1 ? styles.borderbottom : ''}`} >
         <div className={styles.list}>
            <div className={styles.label}>Service Type</div>
            <div className={styles.value}>{detail?.serviceType?.label}</div>
         </div>
         {detail?.cpName!==null&&(
           <div className={styles.list}>
           <div className={styles.label}>TADIG Code</div>
           <SecondaryTooltip text={detail?.cpName} positions={['bottom', 'right']}><div className={`${styles.value} ${styles.valueText}`}>{detail?.cpName}</div></SecondaryTooltip>
        </div>
         )}
          {detail?.serviceType?.value===Incident_Service_Type_Values.IPX_Service && myRights.userType!==USER_TYPE.CUSTOMER&&(
          <> <div className={styles.list}>
          <div className={styles.label}>Invoice code</div>
          <SecondaryTooltip text={(detail?.fincaTadigCode === null || detail?.fincaTadigCode === ""|| !detail.hasOwnProperty('fincaTadigCode')) ? '---':detail.fincaTadigCode} positions={['bottom', 'right']}><div className={`${styles.value} ${styles.valueText}`}>
            {(detail?.fincaTadigCode === null || detail?.fincaTadigCode === ""|| !detail.hasOwnProperty('fincaTadigCode')) ? '---':detail.fincaTadigCode}
          </div></SecondaryTooltip>
        </div>
         </> )}
        {detail?.serviceType?.value===Incident_Service_Type_Values.IVC_Service && myRights.userType!==USER_TYPE.CUSTOMER&&(
          <>
            <div className={styles.list}>
             <div className={styles.label}>Account Number</div>
             <div className={styles.value}>{detail?.accountNumber}</div>
            </div>
            <div className={styles.list}>
              <div className={styles.label}>Account Abbreviation</div>
              <div className={styles.value}>{detail?.accountAbbr}</div>
            </div>
            <div className={styles.list}>
              <div className={styles.label}>IVC Service Name</div>
              <div className={styles.value}>{detail?.oneITSMAccountServiceName?detail?.oneITSMAccountServiceName:"---"}</div>
            </div>
                </>
              )}
          <div className={styles.list}>
            <div className={styles.label}>Account Manager Contact</div>
            <SecondaryTooltip copy={true} text={detail?.customerAccountManagers?.map((item)=>item.email)} positions={['bottom', 'right']}><div className={`${styles.value} ${styles.valueText} ${styles.breakline}`}>{detail?.customerAccountManagers?.map((item)=>item.name)}</div></SecondaryTooltip>
         </div>
        </div>
      </>
         )}
     </div>
     </div>
    )
  };
  const ApprovalContainer = ({ data, myRights }) => {
   
    return (
      <div className={styles.containerapproval}>
      <div className={styles.actionContent}>
        <div className={styles.feedbackcontent}>
        {`To proceed with onboarding this customer, kindly approve the request. ${myRights?.functionalRoles[0] === FUNCTIONAL_ROLES_CONSTANTS["commercial_manager_internal"]?.value?`If you have any questions, click 'Need More Info.' `:""} If you have any concerns, you also have the option to reject the request`}
        </div>
        <div className={styles.feedbacaction}>
          <div className={styles.feedbackbtn}>
          <SectionGuard canAccess={CAN(Action.CREATE_COMMENT, Resource.CUSTOMER_ONBOARDING_APPROVAL)}>
           <AddComment source={'addComment'} data={data} />
          </SectionGuard>
          <SectionGuard canAccess={CAN(Action.APPROVER, Resource.CUSTOMER_ONBOARDING_REQUEST)}>
           <AddComment source="Reject" data={data}/>
           <AddComment source="Approve" data={data}/>
          </SectionGuard>
          </div>
        </div>
      </div>
     </div>
    )
  };

  const CommentDetail = ({data,myRights}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const handleToggle = () => {
      setIsExpanded(!isExpanded);
    };
    // const text = data?.commentMessage
    // const previewText = text?.slice(0, 100);
    function getInitials(name) {
      const displayName = name.split(' ').filter(word => isNaN(word) && word).filter((_, i, arr) => i === 0 || i === arr.length - 1)
      .map(word => word[0]).join('').toUpperCase();
      return displayName;
    }
    // const showViewMore = text?.length>100

    
    const text = data?.commentMessage ? data.commentMessage.split('\n').map((line, index, arr) => {
      if (index === arr.length - 1) {
        return <span key={index}>{line}</span>;
      } else {
        return <div key={index}>{line}</div>;
      }
    }) : "---";
  
    const previewText = data.commentMessage?.slice(0, 100);
    const newlineIndex = data.commentMessage?.indexOf('\n');
    const newline = newlineIndex !== -1 ? data.commentMessage?.slice(0, newlineIndex) : data.commentMessage;
    const showViewMore = data.commentMessage?.length > 100 ||  data.commentMessage?.includes('\n');
    let splitdata = previewText?.split("\n")

    return (
      <div className={styles.commentContainer}>
      <div className={styles.initalshead}>
        <div className={styles.userp}>
          <span className={`${data?.createdBy?.email === myRights?.email?styles.inital:styles.servicedesk}`}>{getInitials(data?.createdBy?.name)}</span>
          <span className={styles.initatname}>{data?.createdBy?.name}</span>
        </div>
        <div className={styles.attachments}>
          Posted On:
          <span className={styles.date}>
            {formatDate(data?.createdAt)}
          </span>
        </div>
      </div>
      <div className={styles.commenttext}>
        {/* {isExpanded ? text : `${previewText}${showViewMore?"...":""}`} */}
        {isExpanded ? text : (
       newlineIndex === -1 ? (
       splitdata.map((word, index) => (
      index === splitdata.length - 1 ? (
        <span className={styles.info}key={index}>{word}</span>
      ) : (
        <div className={styles.info} key={index}>{word}</div>
      )
    ))
  ) : (
    <span className={styles.info}>{newline}</span>
  )
)}
        {showViewMore&&(
          <span className={styles.viewMore} onClick={handleToggle}>
           {isExpanded ? " View Less" : " View More"}
          </span>
        )}
      </div>
    </div>
    );
  };


const OnboardingDetail = (props)=> {
  let { requestId } = useParams();
  const notificationId = useNotificationId();
  useEffect(() => {
    if (notificationId) {
      const payload = { read: true };
      props?.ReadNotification(payload,notificationId)
    }
  }, [notificationId]);
  useEffect(() => {
    props.getOnBoardingApprovalDetail(requestId);
    let next=null;
    props.getOnBoardingComments(requestId,next);
    window.scrollTo(0,0);
    return () => {
      props.clearOnboadingComments();
  };
  }, [requestId]);

  const fetchData = () => {
    if (props?.commentsList?.next) {
      props.getOnBoardingComments(requestId,props?.commentsList?.next);
    }
  };

  const onFileDownload=(file)=>{   
    props.downloadFiles(file.originalFileName,file.uniqueFileName)
    .then((result)=>{
        if(result.status){
          const fileData=result.file
          if(fileData?.length>0){
                window.open(fileData?.[0]);
          }
        }else{
          props.showAlertPopup({alertHeader:"Alert"},{alertMessage:"Error while downloding file!"});
        }
      }).catch((error)=>{
       props.showAlertPopup({alertHeader:"Alert"},{alertMessage:"Something went wrong!"});
      })
    }

  return (
    <Container>
      <Banner image={IMAGES.vfbanner} text={"Onboarding Approvals"}></Banner>
      <ChildContainer>
       {/* {props.requestDetails.map((item) => (
        <CommercialMlist data={item}/>
        ))} */}
         {props?.requestDetails.loading?
           <div className={styles.comentsLoader}>
           <Loader />
         </div>:
         <>
          <OnboargingDetailList data={props?.requestDetails?.onBoardingApprovalDetail} myRigths={props.myRights} onFileDownload={onFileDownload}/>
          <OnboargingDetail data={props?.requestDetails.onBoardingApprovalDetail} myRights={props.myRights}/>
         </>}
         {props?.requestDetails.onBoardingApprovalDetail?.requestStatus?.value===ON_BOARDING_STATUS.PENDING&& !props?.requestDetails.loading &&(
          <ApprovalContainer data={props?.requestDetails.onBoardingApprovalDetail} myRights={props.myRights}/>
          )}
          <div  className={styles.initaltext}>Comment History</div>
          {props?.commentsList?.isLoading && props?.commentsList?.comments.length == 0? (
          <div className={styles.comentsLoader}>
            <Loader />
          </div>
           ) : props?.commentsList?.comments.length  == 0 ? (
            <div className={styles.emptydiv}>No Records Found</div>
           ) : (
           <InfiniteScroll
            dataLength={props?.commentsList?.comments.length} //This is important field to render the next data
            next={() => {
            fetchData();
             }}
            hasMore={props?.commentsList?.next}
            loader={<Loader />}
          >
          {props?.commentsList?.comments?.map((item) => (
            <CommentDetail data={item} myRights={props.myRights}/>
          ))}
        </InfiniteScroll>
      )}
      </ChildContainer>
    </Container>
  )
};

export default OnboardingDetail;